export default {
    ADD_TEMPLATED_CLUSERLET: 'ADD_TEMPLATED_CLUSERLET',
    EDIT_TEMPLATE: 'EDIT_TEMPLATE',
    UPDATE_FULL_TEMPLATE: 'UPDATE_FULL_TEMPLATE',
    DELETE_TEMPLATE: 'DELETE_TEMPLATE',
    RESET_TEMPLATE: 'RESET_TEMPLATE'
}